import { Divider } from '@mui/material';
export default function FormDivider(props) {
    var value = props.value, children = props.children;
    return /*#__PURE__*/ React.createElement(Divider, props, value !== null && value !== void 0 ? value : children);
}
